import FormCurrencyInputFancy from '@c/forms/controls/FormCurrencyInputFancy';
import FormLabel from '@c/forms/controls/FormLabel';
import FormTextarea from '@c/forms/controls/FormTextarea';
import Button from '@ui/Button';
import { getNumber } from '@util/createListingHelpers';
import { chargeAccount, createTransfer } from '@util/firestore/payments';
import { logError } from '@util/logError';
import { UserDocument } from '@util/types/firestore/users';
import { useToastContext } from 'context/ToastContext';
import React from 'react';
import BaseModal from './BaseModal';

const ChargeOrAddFundsModal = ({
  isOpen,
  dismiss,
  seller,
  variant,
}: {
  isOpen: boolean;
  dismiss: () => void;
  seller: UserDocument;
  variant: 'charge' | 'add';
}) => {
  const [loading, setLoading] = React.useState(false);
  const [amount, setAmount] = React.useState(0);
  const [description, setDescription] = React.useState('');
  const [error, setError] = React.useState('');
  const { showSuccessToast } = useToastContext();

  const chargeOrAddFunds = async () => {
    if (!amount) {
      setError('Please enter an amount');
      return;
    }
    setError('');
    try {
      setLoading(true);
      if (variant === 'charge') {
        await chargeAccount(seller.account_id!, amount, description);
        showSuccessToast('Successfully charged seller');
      } else {
        await createTransfer(seller.account_id!, amount, description);
        showSuccessToast('Successfully added funds to seller account');
      }
      setLoading(false);
      dismiss();
    } catch (e: any) {
      logError(e);
      setError((e as Error)?.message || e.toString());
    }
    setLoading(false);
  };

  return (
    <BaseModal
      isOpen={isOpen}
      dismiss={dismiss}
      title={
        <span className="text-[1.8rem] font-semibold">
          {variant === 'charge' ? 'Charging' : 'Adding funds'} Seller:{' '}
          {seller.username}
        </span>
      }
    >
      <div className="mx-auto flex h-full w-full max-w-[30rem] flex-col items-center justify-center gap-[2.4rem]">
        {error && (
          <div className="text-center font-semibold text-red-500">{error}</div>
        )}
        <FormLabel value="Amount">
          <FormCurrencyInputFancy
            value={amount}
            full
            onChange={(e) => setAmount(getNumber(e.target.value))}
          />
        </FormLabel>
        <FormLabel value="Description">
          <FormTextarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </FormLabel>
        <Button
          onClick={chargeOrAddFunds}
          width="fluid"
          text={
            variant === 'charge'
              ? 'Charge Seller'
              : 'Add funds to Seller account'
          }
          type={variant === 'charge' ? 'error' : 'success'}
          loading={loading}
        />
      </div>
    </BaseModal>
  );
};

export default ChargeOrAddFundsModal;
